import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { observer } from 'mobx-react'
import ACLToggleControl from '../ACLRoleControl/ACLRoleControl'

const ACLUserRoles = observer(({ user, report, firstColWidth, colsWidth }) => {
  return (
    <Flex
      pb="8px"
      pt="8px"
      transition="background .3s"
      _hover={{
        backgroundColor: 'brand.lightGray',
      }}
      borderBottom="1px solid"
      borderColor="brand.lightGray">
      <Box
        w={firstColWidth}
        minW={firstColWidth}
        overflow="hidden">
        <Text
          fontSize="14px"
          fontWeight="bold">
          {user.name}
        </Text>
        <Text
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          fontSize="12px">
          {user.email}
        </Text>
        <Text
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          fontSize="12px">
          {user.accessRoleId}
        </Text>
      </Box>
      <Flex alignItems="center">
        {report
          ? report.sections?.map(role => (
              <Flex
                w={colsWidth}
                minW={colsWidth}
                overflow="hidden"
                key={role.id}
                alignItems="center"
                justifyContent="center">
                <ACLToggleControl
                  reportId={report.id}
                  roleId={role.id}
                  userId={user.id}
                />
              </Flex>
            ))
          : 'No users found.'}
      </Flex>
    </Flex>
  )
})

ACLUserRoles.propTypes = {}

export { ACLUserRoles }
